import { createSelector } from 'reselect'

import {
  networkGroup,
  params,
} from './utils'

const bookingForms = state => state.bookingform.bookingForms
const configs = state => state.bookingform.configs

const editBookingForm = createSelector(
  bookingForms,
  params,
  (data, params) => {
    const result = data.find(form => form.id == params.id)
    if(!result) return null
    return Object.assign({}, result, {
      yaml_config: result.config.yaml_config,
      json_config: result.config.json_config,
    })
  }
)

const selectors = {
  bookingForms,
  configs,
  editBookingForm,
  ...networkGroup('admin', [
    'loadProjects',
    'updateProject',
    'loadBookingforms',
    'loadBookingformConfigs',
    'saveBookingform',
    'deleteBookingform',
    'updateSlotOverrides',
    'resetSlotOverrides',
    'updateSlotBlocked',
    'saveBooking',
    'deleteBooking',
  ])
}

export default selectors
